module.exports = __webpack_public_path__ + "cca2de43077289fdd4bc1d50c0bb0368.fbx";